import { ApolloError } from "@apollo/client";
import React, { useMemo } from "react";
import { GET_FORM_ADDRESS_ANSWERS_FOR_FILTER } from "src/components/Form/graphql/queries";
import { useRemoteDataQuery } from "src/hooks/useRemoteDataQuery";
import { FormAddress, FormAddressSchema } from "src/schemas/Address";
import * as GQL from "src/types/graphql";
import { RemoteData } from "src/types/remoteData";

type Props = {
  formId: uuid;
};

type ReturnType = {
  remoteData: RemoteData<ApolloError, FormAddress | undefined>;
  refetch: () => Promise<void>;
};
export function useFormAddresForFilter({ formId }: Props): ReturnType {
  const { remoteData, refetch: refetchFormAddress } = useRemoteDataQuery<
    GQL.GetFormAddressAnswersForFilter,
    GQL.GetFormAddressAnswersForFilterVariables
  >(GET_FORM_ADDRESS_ANSWERS_FOR_FILTER, {
    variables: {
      form_id: formId,
    },
    fetchPolicy: "network-only",
  });

  const address = useMemo(
    () =>
      remoteData.map((data) =>
        data.form_address[0]
          ? FormAddressSchema.parse(data.form_address[0])
          : undefined
      ),
    [remoteData]
  );

  const refetch = React.useCallback(async () => {
    await refetchFormAddress();
  }, [refetchFormAddress]);
  return { remoteData: address, refetch };
}
